<template>
  <Content
    class="col-span-full"
    :title="$route.name"
    :router="{
      name: 'tags_list',
    }"
  >
    <el-form
      status-icon
      :model="ruleForm"
      :rules="rules"
      label-position="top"
      ref="ruleForm"
      label-width="120px"
      class="carpo-form demo-ruleForm"
    >
      <el-form-item
        :label="$t('FA_TITLE')"
        prop="fa_title"
        :rules="{
          required: true,
          message: $t('REQUIRED_FIELD', {
            type: $t('FA_TITLE'),
          }),
          trigger: 'blur',
        }"
      >
        <el-input
          :disabled="ruleForm.disabled"
          type="text"
          v-model="ruleForm.fa_title"
          autocomplete="off"
        ></el-input>
      </el-form-item>

      <el-form-item
        :label="`${$t('EN_TITLE')}`"
        prop="en_title"
        :rules="{
          required: true,
          message: $t('REQUIRED_FIELD', {
            type: $t('EN_TITLE'),
          }),
          trigger: 'blur',
        }"
      >
        <el-input
          type="text"
          v-model="ruleForm.en_title"
          autocomplete="off"
        ></el-input>
      </el-form-item>

      <FormConfirmation
        v-show="!ruleForm.disabled"
        @resetForm="resetForm('ruleForm')"
        @submitForm="submitForm('ruleForm')"
        :edit="null"
        :loading="submitLoading"
      />
    </el-form>
  </Content>
</template>
<script>
import { resetForm } from '@/mixins/resetForm'
import FormConfirmation from '@/components/elements/formConfirmation.vue'
import { addTag } from '@/api/cars'

export default {
  mixins: [resetForm],
  components: {
    FormConfirmation,
  },
  data() {
    return {
      submitLoading: false,

      ruleForm: {
        fa_title: '',
        en_title: '',
      },

      rules: {},
    }
  },

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const actionPayload = {
            fa_title: this.ruleForm.fa_title,
            en_title: this.ruleForm.en_title,
          }

          this.submitLoading = true
          addTag.api(actionPayload).then((res) => {
            this.submitLoading = false
            if (res) {
              this.$notify.success({
                title:
                  this.$t(this.$route.name) +
                  ' ' +
                  this.$t('SUCCESSFULLY_DONE'),
                duration: 5000,
                customClass: 'succ_msg',
              })
              this.resetForm(formName)
            }
          })
        } else {
          this.$notify.error({
            title: this.$i18n.t('FIXED_ERRORS', {
              type: this.$i18n.t(this.$route.name),
            }),
            duration: 5000,
            customClass: 'error_msg',
          })
          return false
        }
      })
    },
  },
}
</script>
